import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/page_main_1.webp'
import _imports_1 from '../images/page_main_2.webp'
import _imports_2 from '../images/page_main_3.webp'
import _imports_3 from '../images/page_main_4.webp'
import _imports_4 from '../images/mobile_page_main_1.webp'
import _imports_5 from '../images/mobile_page_main_2.webp'
import _imports_6 from '../images/mobile_page_main_3.webp'
import _imports_7 from '../images/mobile_page_main_4.webp'


const _withScopeId = n => (_pushScopeId("data-v-4821a470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tetrapak-main" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content1 d-none d-md-flex\" data-v-4821a470><div class=\"child1\" data-v-4821a470><img src=\"" + _imports_0 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div><div class=\"child2\" data-v-4821a470><img src=\"" + _imports_1 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div><div class=\"child3\" data-v-4821a470><img src=\"" + _imports_2 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div></div><div class=\"content2 d-none d-md-flex\" data-v-4821a470><div class=\"child1\" data-v-4821a470><img src=\"" + _imports_3 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div></div><div class=\"content1 d-flex d-md-none\" data-v-4821a470><div class=\"child1\" data-v-4821a470><img src=\"" + _imports_4 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div><div class=\"child2\" data-v-4821a470><img src=\"" + _imports_5 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div><div class=\"child3\" data-v-4821a470><img src=\"" + _imports_6 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div></div><div class=\"content2 d-flex d-md-none\" data-v-4821a470><div class=\"child1\" data-v-4821a470><img src=\"" + _imports_7 + "\" alt=\"\" class=\"img-fluid\" data-v-4821a470></div></div>", 4)

import { ref, computed, watch } from 'vue';
import Navbar from './navbar.vue';
import { useElementBounding } from '@vueuse/core';

interface Props {
  modelValue: boolean;
  activeMenuIndex: number;
  menus: {
    name: string;
    mobileName?: string;
    disabled?: boolean;
  }[];
}
interface Emits {
  (event: 'update:modelValue', val: boolean): void;
  (event: 'menu-click', menu: Props['menus'][number]): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean },
    activeMenuIndex: null,
    menus: null
  },
  emits: ["update:modelValue", "menu-click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:modelValue', val: boolean): void;
  (event: 'menu-click', menu: Props['menus'][number]): void;
}), expose: any, slots: any, attrs: any }) {




const navContainer = ref<HTMLDivElement>();
const { top, height } = useElementBounding(navContainer);
const targetIsVisible = computed(() => {
  const tcHeaderHeight = parseInt(document.body.style.getPropertyValue('--tc-header-height')) || 0;
  return (top.value - tcHeaderHeight) + height.value > 0;
});

watch(
  () => targetIsVisible.value,
  (val) => {
    emits('update:modelValue', val);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      ref_key: "navContainer",
      ref: navContainer,
      class: "nav-container"
    }, [
      _createVNode(Navbar, {
        "active-menu-index": __props.activeMenuIndex,
        menus: __props.menus,
        sticky: false,
        onMenuClick: _cache[0] || (_cache[0] = ($event: any) => (emits('menu-click', $event)))
      }, null, 8, ["active-menu-index", "menus"])
    ], 512)
  ]))
}
}

})